<template>
  <div id="BillDetail">
    <subTitle :title="$t(`我的账单记录`)" :tip="$t(`提示：当月用量统计截止昨天24:00。`)"></subTitle>
    <div class="open-table-search">
      <div class="open-table-search-list">
        <span class="search-text">{{ $t('账单时间') }}</span>
        <es-date-picker
          class="search-fun"
          v-model="search.startTime"
          type="month"
          :placeholder="$t(`选择日期`)"
          value-format="yyyy-MM"
          :picker-options="pickerOptions"
        >
        </es-date-picker>
      </div>
      <div class="open-table-search-list" v-if="!isPartner">
        <span class="search-text">{{ $t('平台名称') }}</span>
        <es-select v-model="search.platformId" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="(key, index) in platformList" :key="index" :label="key.name" :value="key.appId"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list" v-if="!isPartner">
        <span class="search-text">{{ $t('产品名称') }}</span>
        <es-select v-model="search.proId" :placeholder="$t(`请选择`)" @change="changePro()" class="search-fun">
          <es-option v-for="(item, index) in proList" :key="index" :label="item.productName" :value="item.productId"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list">
        <span class="search-text">{{ $t('订单编号') }}</span>
        <es-select v-model="search.orderId" :placeholder="$t(`请选择`)" class="search-fun" :disabled="isPartner || !!search.authedGid">
          <es-option
            v-for="(key, value) in orderList"
            :key="value"
            :label="key.showId"
            :value="key.id"
            v-show="key.showId && key.productId == search.proId"
          ></es-option>
        </es-select>
      </div>
      <div v-if="hasAuthedGid" class="open-table-search-list">
        <span class="search-text">{{ $t('实际使用方') }}</span>
        <es-select v-model="search.authedGid" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="item in authedList" :key="item.gid" :label="item.gidName" :value="item.gid"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list search-submit">
        <es-button @click="searchList()" type="primary" :loading="loadingButton">{{ $t('查询') }}</es-button>
        <es-button @click="clear()" variant="outline" v-if="!isPartner">{{ $t('清空') }}</es-button>
        <es-button @click="showExport" type="primary" style="margin-left: 15px">{{ $t('导出') }}</es-button>
      </div>
    </div>

    <divided />
    <div class="common-body">
      <div class="tip">
        {{ realTime }} &nbsp;{{
          $t('共用掉{amount}{units}', {
            amount,
            units,
          })
        }}
        <es-popover placement="bottom" title="公告" width="300" trigger="hover">
          <div>您好！以下产品涉及名称更改，订单和消费明细可能存在新老名称同时出现的情况，敬请谅解。</div>
          <div>
            <es-link type="primary" href="https://open.esign.cn/doc/opendoc/notice/tgsfchv64gsyienc">
              2023/05/18-关于调整部分商品的公告</es-link
            >
          </div>
          <span style="color: red; float: right" slot="reference" v-show="flagData[currentEnv].includes(search.proId)">产品更名公告</span>
        </es-popover>
      </div>
      <div class="table">
        <es-row class="table-title" :style="{ width: nowTitle.length * 180 + 'px' }">
          <es-col v-for="(item, index) in nowTitle" :key="index">{{ item.name }}</es-col>
        </es-row>
        <es-row class="table-main" v-for="(item, index) in billDetailList" :key="index" :style="{ width: nowTitle.length * 180 + 'px' }">
          <es-col v-for="(title, index) in nowTitle" :key="index">
            {{ item[title.field] | fomatType(title.field) }} {{ title.field == 'amount' ? formatUnit(item.units) : '' }}&nbsp;
          </es-col>
        </es-row>
        <es-row class="noData" v-show="billDetailList.length === 0">
          <es-empty
            style="margin: 25px; color: #999; line-height: 40px"
            :description="$t(`暂无更多数据`)"
            image="data:image/png;base64,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"
            :image-size="64"
          ></es-empty>
        </es-row>
        <es-dialog
          :title="$t(`导出消费记录`)"
          :visible.sync="dialogVisible"
          width="800px"
          :before-close="initExport"
          :close-on-click-modal="false"
        >
          <div slot="title" style="display: flex; justify-content: space-between">
            <div style="line-height: 28px">{{ $t('导出消费记录') }}</div>
            <div>
              <es-button type="text" @click="showExportHistory" style="margin-right: 25px">{{ $t('已导出记录查询') }}</es-button>
            </div>
          </div>

          <es-row style="margin: 20px">
            <div class="load" v-if="status === 'init'">
              <div class="form-desc" v-if="exportType === 'BIGDATA'">
                {{ $t('导出结果中暂不包含当日耗用数据，敬请谅解') }}
              </div>

              <es-form :model="exportForm">
                <es-form-item :label="$t(`产品名称`)" :rules="[{ required: true, message: $t('请选择产品名称'), trigger: 'blur' }]">
                  <es-select v-model="exportForm.productId" filterable :placeholder="$t(`请选择`)" class="search-fun">
                    <es-option v-for="(item, index) in proList" :key="index" :label="item.productName" :value="item.productId"></es-option>
                  </es-select>
                </es-form-item>
                <es-form-item :label="$t(`月度区间`)" :rules="[{ required: true, message: $t('请选择月度区间'), trigger: 'blur' }]">
                  <es-date-picker
                    v-model="exportMonth"
                    type="monthrange"
                    range-separator="-"
                    :start-placeholder="$t(`开始月份`)"
                    :end-placeholder="$t(`结束月份`)"
                    @change="transformDate(exportMonth)"
                    :picker-options="pickerOptionsMonth"
                  >
                  </es-date-picker>
                </es-form-item>

                <div v-if="exportType === 'BIGDATA'">
                  <es-form-item :label="$t(`平台名称`)" :rules="[{ required: false, message: $t('请选择平台名称'), trigger: 'blur' }]">
                    <es-select v-model="exportForm.appId" filterable clearable :placeholder="$t(`请选择`)" class="search-fun">
                      <es-option v-for="(key, index) in platformList" :key="index" :label="key.name" :value="key.appId"></es-option>
                    </es-select>
                  </es-form-item>
                  <es-form-item :label="$t('接收邮箱')" :rules="[{ required: false }]">
                    <es-input v-model="exportForm.email" :placeholder="$t('请输入邮箱地址')" class="search-fun"></es-input>
                  </es-form-item>
                </div>
              </es-form>
            </div>
            <div class="load" v-if="status === 'loading' && this.exportType !== 'BIGDATA'">
              <img src="@/assets/common/load.png" style="width: 12px; height: 12px" />
              <span>&nbsp;{{ $t('消费记录生成中，请稍等…') }}&nbsp;</span>
            </div>
            <div class="load" v-show="status == 1">
              <div>
                <span> {{ urls.updateTime | formatUtc }} </span>
                <es-button type="text" style="margin-left: 20px" @click="downLoad(urls.url)">
                  {{ urls.productName + formatUtc(urls.startTime, 'month') + $t('至') + formatUtc(urls.endTime, 'month') }}&nbsp;{{
                    $t('明细下载')
                  }}</es-button
                >
              </div>
            </div>
          </es-row>

          <span slot="footer">
            <es-button type="primary" @click="recordExport" v-if="status === 'init'">{{ $t('导出') }}</es-button>
            <es-button type="primary" @click="initExport" v-else>{{ $t('关闭') }}</es-button>
          </span>
        </es-dialog>

        <es-dialog :visible.sync="exportSuccess" :show-close="false" class="export-success" v-if="this.exportType === 'BIGDATA'">
          <div class="export-success-title">
            <img src="../../assets/icons/check-circle-fill.svg" alt="" />
            <div>{{ $t('提交成功') }}</div>
          </div>
          <div class="export-success-desc">{{ $t('系统将在2个工作日内将对应消费记录发送到对应邮箱，或可查询已导出记录进行自助下载') }}</div>

          <div class="export-success-password">{{ $t('解压密码为：') }}{{ this.zipPassword }}</div>

          <span slot="footer" class="export-success-footer">
            <es-button type="primary" @click="exportSuccess = false">{{ $t('关闭') }}</es-button>
          </span>
        </es-dialog>

        <es-dialog :title="$t(`已导出消费记录`)" :visible.sync="listDialogVisible" width="70%">
          <div slot="title" style="display: flex; justify-content: space-between">
            <div>{{ $t('已导出消费记录') }}</div>
            <div style="margin-right: 25px">
              <es-select
                v-model="historyProductId"
                clearable
                filterable
                @change="getHistorylist"
                :placeholder="$t(`请选择产品名称筛选`)"
                class="search-fun"
              >
                <es-option :label="$t(`全部产品`)" value=""></es-option>
                <es-option v-for="(item, index) in proList" :key="index" :label="item.productName" :value="item.productId"></es-option>
              </es-select>
            </div>
          </div>

          <es-table :data="hisUrls" style="width: 100%">
            <es-table-column prop="productName" :label="$t('文件名')" width="380">
              <template slot-scope="scope">
                <span>{{
                  scope.row.productName + formatUtc(scope.row.startTime, 'month') + $t('至') + formatUtc(scope.row.endTime, 'month')
                }}</span>
              </template>
            </es-table-column>
            <es-table-column prop="endTime" :label="$t('导出时间')" width="180">
              <template slot-scope="scope">
                <span>{{ formatUtc(scope.row.updateTime) }}</span>
              </template>
            </es-table-column>
            <es-table-column prop="endTime" :label="$t('导出结果')" width="180">
              <template slot-scope="scope">
                <es-tag size="mini" :type="getTagType(scope.row)">{{ getStatusMess(scope.row) }}</es-tag>
              </template>
            </es-table-column>
            <es-table-column prop="productName" :label="$t('明细下载')" width="180">
              <template slot-scope="scope">
                <es-button
                  type="text"
                  :disabled="scope.row.isDisable || scope.row.status === 2 || scope.row.status === 0"
                  @click="downLoad(scope.row.url)"
                >
                  {{ $t('明细下载') }}
                </es-button>
              </template>
            </es-table-column>
            <es-table-column prop="zipPwd" :label="$t('解压密码')" width="180">
              <template slot-scope="scope">
                <span class="export-zipPwd">
                  {{ scope.row.zipPwd || $t('未加密') }}
                </span>
              </template>
            </es-table-column>
          </es-table>

          <es-pagination
            small
            layout="prev, pager, next"
            :total="hisPageData.rowCount"
            @current-change="hisPageChange"
            :current-page.sync="hisPageData.currentPage"
            style="text-align: right; margin: 5px 0"
            hide-on-single-page
          >
          </es-pagination>
          <span slot="footer">
            <es-button type="primary" @click="listDialogVisible = false">{{ $t('好的') }}</es-button>
          </span>
        </es-dialog>
      </div>
      <es-pagination
        style="text-align: right; margin: 20px 0"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        layout="prev, next"
        v-show="billDetailList.length > 0"
        :total="count"
      >
      </es-pagination>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import subTitle from '@/components/subTitle'
import divided from '../../components/divided'
import { mapState } from 'vuex'
import { formatUtc } from '@/util.js'

export default {
  components: {
    subTitle,
    divided,
  },
  computed: {
    ...mapState({
      isAdmin: state => state.userInfo.isAdmin,
      isPartner: state => state.isPartner,
      isOrg: state => state.isOrg,
    }),
    span() {
      return screen.width <= 1440 ? 8 : 6
    },
    offset() {
      return screen.width <= 1440 ? 8 : 18
    },
    hasAuthedGid() {
      return Object.prototype.hasOwnProperty.call(this.$route.query, 'authedGid')
    },
  },
  data() {
    let startTime
    if (this.$route.query.year && this.$route.query.month) {
      startTime = `${this.$route.query.year}-${this.$route.query.month}`
    } else {
      const date = new Date()
      startTime = `${date.getFullYear()}-${date.getMonth() + 1}`
    }

    return {
      exportType: '', // HBASE表示老的导出, BIGDATA表示新的导出
      zipPassword: '',
      formatUtc,
      dialogVisible: false,
      listDialogVisible: false,
      exportSuccess: false,
      pickerOptions: {
        disabledDate(time) {
          const date = new Date()

          return time.getTime() < date.getTime() - 365 * 3600 * 1000 * 24 * 2
        },
      },
      monthRange: [],
      pickerOptionsMonth: {
        disabledDate(time) {
          const curMonth = new Date()
          const twoYearAgo = new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}`)
          twoYearAgo.setMonth(new Date().getMonth() - 24) // 获取两年前月初0点时刻

          return time.getTime() > curMonth || time.getTime() < twoYearAgo // 只能选择两年前到现在的月份，组件bug需要把默认时间设置为8:00:00
        },
      },
      time: '', // 导出记录时间
      exportForm: {},
      exportMonth: [],
      clock: null,
      exportLoading: false,
      currentPage: 1,
      units: '',
      realTime: '',
      loadingButton: false,
      historyProductId: null,
      search: {
        startTime,
        platformId: '',
        proId: Number(this.$route.query.proId) || '',
        orderId: this.$route.query.orderId || '',
        authedGid: this.$route.query.authedGid || '',
      },
      proList: [],
      platformList: [],
      orderList: [],
      billDetailList: [],
      amount: 0,
      count: 0,
      titleList: this.$Dic.getTitle(),
      nowTitle: [],
      status: 0,
      urls: [],
      hisUrls: [],
      isShowTotal: true,
      hisPageData: {},
      currentEnv: process.env.VUE_APP_MODE || 'test',
      flagData: {
        dev: [35, 1454],
        test: [35, 1454],
        sml: [35, 300],
        prod: [35, 494],
      },
    }
  },
  methods: {
    getTagType(row) {
      if (row.isDisable) {
        return 'info'
      }

      if (row.status === 1) {
        return 'success'
      }

      return 'info'
    },
    getStatusMess(row) {
      if (row.isDisable) {
        return $t('已过期')
      }

      if (row.status === 0) {
        return $t('导出中')
      }
      if (row.status === 1) {
        return $t('导出成功')
      }
      if (row.status === 2) {
        return $t('导出失败')
      }
    },
    initExport() {
      this.dialogVisible = false
      clearInterval(this.clock)
      this.status = 'init'
    },
    changePro() {
      this.search.orderId = ''
    },
    clear() {
      this.search.platformId = ''
      if (!this.search.authedGid) {
        this.search.orderId = ''
      }
      this.searchList()
    },
    // 搜索
    searchList() {
      this.currentPage = 1
      if (!this.search.proId) {
        return this.$message.error($t('请选择产品'))
      }
      this.getBillDetailList()
    },
    currentChange(val) {
      this.currentPage = val
      this.getBillDetailList()
    },
    hisPageChange(val) {
      this.hisPageData.currentPage = val
      this.getHistorylist()
    },
    // 导出状态
    getExportStatus(searchData) {
      const data = JSON.parse(searchData)
      if (this.clock) clearInterval(this.clock)
      this.clock = setInterval(() => {
        this.$ajax(this.$url.exportStatus(), data)
          .then(res => {
            this.status = res.data.status
            if (res.data.status === 1) {
              clearInterval(this.clock)
              this.urls = res.data
              this.exportSuccess = false
            } else if (res.data.status === 0) {
              this.status = 'loading'
              this.time = data.month
            } else {
              clearInterval(this.clock)
              this.$message.error($t('导出失败'))
              this.status = 'init'
            }
          })
          .catch(() => {
            clearInterval(this.clock)
          })
      }, 1000)
    },
    transformDate(value) {
      // 5356800000为两个月的毫秒数
      // 12个月的毫秒数28944000000

      if (!value) {
        this.exportForm.year = ''
        this.exportForm.endYear = ''
        this.exportForm.month = ''
        this.exportForm.endMonth = ''

        return
      }

      if (value && value.length && value[1] - value[0] <= 29116800000) {
        this.exportForm.year = new Date(value[0]).getFullYear()
        this.exportForm.endYear = new Date(value[1]).getFullYear()
        this.exportForm.month = new Date(value[0]).getMonth() + 1
        this.exportForm.endMonth = new Date(value[1]).getMonth() + 1
      } else {
        this.exportForm.year = ''
        this.exportForm.endYear = ''
        this.exportForm.month = ''
        this.exportForm.endMonth = ''
        if (value && value.length && value[1] - value[0] > 29116800000) {
          this.$message.error($t('暂不支持超过12个月时间宽度的导出操作'))
          this.exportMonth.splice(0, 2)

          return
        }
      }
    },
    // 展示导出弹窗
    showExport() {
      this.dialogVisible = true
      this.status = 'init'
    },
    showExportHistory() {
      this.getHistorylist()
    },
    getHistorylist() {
      const data = { ...this.exportForm }
      data.productId = this.historyProductId
      data.pageNum = this.hisPageData.currentPage || 1
      this.listDialogVisible = true
      this.$ajax(this.$url.exportHistoryList(), data)
        .then(res => {
          this.hisUrls = res.data || []

          this.hisPageData = res
        })
        .catch(() => {
          this.status = 'init'
        })
    },
    // 导出消费记录
    recordExport() {
      const data = { ...this.exportForm }
      if (!this.exportForm.productId) {
        this.$message.error($t('请输入产品名称'))

        return
      }
      if (!this.exportForm.year) {
        this.$message.error($t('请输入月度区间'))

        return
      }
      const emailreg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
      if (this.exportForm.email && !emailreg.test(this.exportForm.email)) {
        this.$message.error($t('请输入正确的邮箱地址'))

        return
      }

      const exportURL = this.isOrg ? this.$url.recordExportOrganize() : this.$url.recordExportPerson()

      this.status = this.exportType === 'BIGDATA' ? 'init' : 'loading'
      this.$ajax(exportURL, data)
        .then(res => {
          data.exportId = res.data.code
          this.exportType !== 'BIGDATA' && this.getExportStatus(JSON.stringify(data))
          this.zipPassword = res.data.zipPwd

          this.exportSuccess = true
        })
        .catch(() => {
          this.status = 'init'
        })
    },
    // 获取消费记录
    getBillDetailList() {
      const data = {
        productId: this.search.proId,
        year: this.search.startTime.split('-')[0],
        month: this.search.startTime.split('-')[1],
        page: this.currentPage,
      }
      if (this.search.platformId) {
        data.appId = this.search.platformId
      }
      if (this.search.orderId) {
        this.orderList.forEach(item => {
          if (item.id === this.search.orderId) {
            data.poolId = item.poolId
          }
        })
      }
      if (this.search.authedGid) {
        data.authGided = this.search.authedGid
      }
      this.loadingButton = true
      let titleArray = []
      Promise.all([this.$ajax(this.$url.queryExportContextByProductId(this.search.proId)), this.$ajax(this.$url.recordDetail(), data)])
        .then(res => {
          this.getrecordCount()
          // 如果存在后端返回的列头和列表名 否则取前端数据
          if (res[0].data && res[0].data.templateContent) {
            titleArray =
              Object.entries(JSON.parse(res[0].data.templateContent)).map(([name, field]) => {
                return {
                  name,
                  field,
                }
              }) || []
            this.nowTitle = titleArray
            if (this.nowTitle.findIndex(item => item.field === 'costUnit') > 0) {
              this.nowTitle.splice(
                this.nowTitle.findIndex(item => item.field === 'costUnit'),
                1
              )
            }
          } else if (res[1].data.length > 0) {
            this.nowTitle = this.$Dic.getTitle(res[1].data[0]['@c'])
          } else {
            this.nowTitle = this.$Dic.defalutTitle()
          }
          this.loadingButton = false
          this.billDetailList = res[1].data || []
        })
        .catch(() => {
          this.loadingButton = false
        })
      if (this.clock != null) {
        clearInterval(this.clock)
      }
    },
    // 获取平台信息
    getplatformInfo() {
      this.$ajax(this.$url.platformInfo(), {}).then(res => {
        this.platformList = res.data || []
      })
    },
    // 产品名称
    getProList() {
      this.$ajax(this.$url.getproductList()).then(res => {
        this.proList = res.data || []
      })
    },
    // 订单编号
    getOrderList() {
      this.$ajax(this.$url.getAvailableList(), {}).then(res => {
        this.orderList = res.data || []
        this.searchList()
      })
    },
    formatUnit(unit) {
      if (this.saleType === 2) {
        return $t('元')
      } else if (unit === 'G') {
        return 'K'
      }

      return unit
    },
    // 时间和用掉数量
    getrecordCount() {
      const data = {
        productId: this.search.proId,
        year: this.search.startTime.split('-')[0],
        month: this.search.startTime.split('-')[1],
      }
      if (this.search.platformId) {
        data.appId = this.search.platformId
      }
      if (this.search.orderId) {
        this.orderList.forEach(item => {
          if (item.id === this.search.orderId) {
            data.poolId = item.poolId
          }
        })
      }
      if (this.search.authedGid) {
        data.authGided = this.search.authedGid
      }
      this.$ajax(this.$url.recordCount(), data).then(res => {
        this.amount = res.data.amount || 0
        this.count = res.data.count || 0
        this.realTime = this.search.startTime
        this.saleType = res.data.saleType
        // eslint-disable-next-line no-nested-ternary
        this.units = this.saleType === 2 ? $t('元') : res.data.units === 'G' ? 'K' : res.data.units
      })
    },
    downLoad(url) {
      window.open(url)
    },

    getExportType() {
      const getTypeUrl = this.isOrg ? this.$url.getOrganizeExportType() : this.$url.getPersonExportType()

      this.$ajax(getTypeUrl).then(res => {
        this.exportType = res.data
      })
    },
    getAuthedList() {
      if (!this.search.authedGid) return
      const getAuthedListUrl = this.isOrg ? this.$url.getAuthedListByOrg() : this.$url.getAuthedList()
      this.$ajax(getAuthedListUrl, { authOrderId: this.search.orderId }).then(res => {
        this.authedList = res.data || []
        this.authedList.unshift({
          gid: '',
          gidName: $t('全部'),
        })
      })
    },
  },
  mounted() {
    this.getOrderList()
    this.getplatformInfo()
    this.getProList()
    this.getExportType()
    this.getAuthedList()
  },
}
</script>
<style lang="less" scoped>
/deep/ .es-col {
  word-break: break-all;
}

/deep/ .search-fun {
  width: 300px;
}


.export-zipPwd {
  color: #165dff;
}

.export-success-title {
  display: flex;
  justify-content: center;
  margin-bottom: 26px;
}

.export-success-desc {
  color: #666;
  margin-bottom: 16px;
}

.export-success-password {
  color: #1d2129;
  font-size: 16px;
  font-weight: 500;
}

.load {
  position: relative;
  .form-desc {
    position: absolute;
    top: -40px;
    font-weight: bold;
    color: red;
  }
  img {
    width: 12px;
    height: 12px;
  }
  span {
    font-size: 14px;
  }
}
.tip {
  font-weight: 900;
  color: #4b4b4bff;
  font-size: 14px;
  margin-bottom: 15px;
}
.table {
  overflow-x: auto;
}
.table-main,
.table-title {
  min-height: 40px;
  line-height: 40px;
  color: #1c1c1cff;
  min-width: 100%;
  font-weight: 500;
  border-top: 1px solid RGBA(243, 243, 243, 1);
  text-align: center;
  background: #f7f8faff;
  display: flex;
  align-items: center;
  :last-child {
    text-align: center;
  }
}
.table-main {
  min-height: 50px;
  line-height: 50px;
  background: #fff;
  border: 1px solid RGBA(236, 241, 246, 1);
  border-top: none;
  .es-col {
    padding-left: 10px;
  }
}
.width150 {
  max-width: 150px;
}
.search-bar {
  .es-row {
    width: 100%;
  }
  .es-col {
    height: 56px;
    display: flex;
    align-items: center;
  }
}
</style>
